export default {
  // 过滤掉字符串中的_BRIDAL
  filterBridal (val) {
    // 婚纱
    if (val && val.includes('BRIDAL')) {
      val = val.replace('_BRIDAL', '')
    }
    // 影像季
    if (val && val.includes('VIDEO')) {
      val = val.replace('_VIDEO', '')
    }
    return val
  }
}
